import { integrations } from '../data/integrations'

export function SubscribeFrame() {
  if (!integrations.subscribe.enabled) {
    return null
  }

  return (
    <iframe
      className="subscribe-frame"
      height="520"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      src={integrations.subscribe.iframeUrl}
      title="Kampanyalardan haberdar ol"
      width="520"
    />
  )
}
